import restAction from "../common/restAction";

const state = {
  readYn: 0,
  checkTime: null
};
const actions = {
  setTimeDecisionReadYn() {
    let TimeGap = 0;
    let firstCheck = false;
    if (state.checkTime == null) {
      firstCheck = true;
      mutations.setCheckTime(new Date());
    } else {
      const currentTime = new Date();
      TimeGap =
        (currentTime.getTime() - state.checkTime.getTime()) / (1000 * 60);
    }
    if (TimeGap >= 1 || firstCheck) {
      mutations.setCheckTime(new Date());
      const param = {
        url: "/api/copaper/maindecision/getCountDeciProcessByConfirmYn",
        method: "post",
        params: {}
      };
      restAction.actions
        .COWORK_REST_SIMPLE_ACTION({}, param)
        .then(function(res) {
          mutations.setReadYn(res.result);
        })
        .catch(function(err) {
          console.log(err);
        });
    }
  },
  setDecisionReadYn() {
    mutations.setCheckTime(new Date());
    const param = {
      url: "/api/copaper/maindecision/getCountDeciProcessByConfirmYn",
      method: "post",
      params: {}
    };
    restAction.actions
      .COWORK_REST_SIMPLE_ACTION({}, param)
      .then(function(res) {
        mutations.setReadYn(res.result);
      })
      .catch(function(err) {
        console.log(err);
      });
  }
};
const mutations = {
  setReadYn(payload) {
    state.readYn = payload;
  },
  setCheckTime(payload) {
    state.checkTime = payload;
  }
};
const getters = {};

export default { state, actions, mutations, getters, namespaced: true };



// WEBPACK FOOTER //
// ./src/js/store/module/decision/decision.js